import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { exportSearch, selectResultIds, selectResults } from "../searchSlice"
import { Table, Tooltip } from "antd"
import { titleize } from "../../../lib/string"
import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons"
import { getIcon } from "../../../lib/utilities"

export default function AdvancedSearchResults() {
    const dispatch = useDispatch()
    const results = useSelector(selectResults)
    const resultIds = useSelector(selectResultIds)


    // console.log(results)
    
    return (
        <div>
            <h1 className="search-heading">Search Results</h1>
            <div className="card-body-heading">
                <div className="actions">
                    <div className="table-action-links">
                        <button onClick={() => dispatch(exportSearch(resultIds))}>
                            <DownloadOutlined />
                            Export
                        </button>
                    </div>
                </div>
            </div>
            <Table dataSource={results} rowKey={(r) => `${r.type}-${r.id}`}>
                <Table.Column
                    title="Account Number"
                    key="account_number"
                    dataIndex="account_number"
                    sorter={{ compare: (a, b) => a.account_number?.localeCompare(b.account_number) }}
                    showSorterTooltip={false}
                    render={(account_number, account) => (
                        <a href={`/clients/${account.client_id}/${account.type}/${account.id}/bills`} target="_blank">
                            {account_number}
                        </a>
                    )}
                />
                <Table.Column title="Account Name" key="account_name" dataIndex="name" sorter={{ compare: (a, b) => a.name?.localeCompare(b.name) }} showSorterTooltip={false} />

                <Table.Column
                    title="Client Name"
                    key="client_name"
                    dataIndex="client_name"
                    showSorterTooltip={false}
                    render={(client_name, account) => (
                        <a href={`/clients/${account.client_id}/dashboard`} target="_blank">
                            {client_name}
                        </a>
                    )}
                />

                <Table.Column
                    title="Active"
                    key="active"
                    dataIndex="active"
                    render={(active) => (active ? "Active" : "Inactive")}
                    // filterDropdown={({ visible }) => (
                    //     <ColumnToggleFilter
                    //         handleFetchInitial={handleFetchInitialBillableAccounts}
                    //         filterAction={filterBillableAccounts}
                    //         filterColumn={"active"}
                    //         filterType={"active_eq"}
                    //         filters={filters}
                    //         pagination={pagination}
                    //         setFilters={setFilters}
                    //         sort={sort}
                    //         setSort={setSort}
                    //         facilityId={facilityId}
                    //         visible={visible}
                    //     />
                    // )}
                    // filterIcon={() => renderSearchOutlinedButton("active_eq")}
                />

                <Table.Column title="Vendor" key="vendor_name" dataIndex="vendor_name" sorter={{ compare: (a, b) => a.vendor_name?.localeCompare(b.vendor_name) }} showSorterTooltip={false} />

                {/* <Table.Column title="Type" key="type" dataIndex="type" sorter={{ compare: (a, b) => a.type?.localeCompare(b.type) }} showSorterTooltip={false} render={(i) => titleize(i)} /> */}
                <Table.Column
                    title="Address"
                    key="full_address"
                    dataIndex="full_address"
                    sorter={{ compare: (a, b) => a.full_address?.localeCompare(b.full_address) }}
                    showSorterTooltip={false}
                    // render={(i) => titleize(i)}
                />
                {/* <Table.Column title="Services" key="services" dataIndex="services" sorter={{ compare: (a, b) => a.services?.localeCompare(b.services) }} showSorterTooltip={false} /> */}
                <Table.Column
                    title="Service(s)"
                    key="service_types"
                    dataIndex="service_types"
                    render={(text, record) => {
                        // console.log(text)
                        // const services = text.split(',')
                        return text.map((s, i) => <Tooltip title={`${s.name} (${s.symbol})`}>{getIcon(s.name)}</Tooltip>)
                    }}
                />
                {/* <Table.Column
                    title="Facility Code"
                    key="facility_code"
                    dataIndex="facility_code"
                    sorter={{ compare: (a, b) => a.facility_code?.localeCompare(b.facility_code) }}
                    showSorterTooltip={false}
                /> */}
                <Table.Column
                    title="Facility Code"
                    key="facility_number"
                    dataIndex="facility_number"
                    sorter={{ compare: (a, b) => a.facility_number?.localeCompare(b.facility_number) }}
                    showSorterTooltip={false}
                />
                <Table.Column
                    title="Facility Name"
                    key="facility_name"
                    dataIndex="facility_name"
                    sorter={{ compare: (a, b) => a.facility_name?.localeCompare(b.facility_name) }}
                    showSorterTooltip={false}
                />

                <Table.Column
                    title="Last Bill Date"
                    key="last_bill_date"
                    dataIndex="last_bill_date"
                    sorter={{ compare: (a, b) => a.last_bill_date?.localeCompare(b.last_bill_date) }}
                    showSorterTooltip={false}
                />

                <Table.Column
                    title="Bill Image"
                    key="last_bill_file_url"
                    dataIndex="last_bill_file_url"
                    showSorterTooltip={false}
                    render={(url) =>
                        url ? (
                            <a href={url} target="_blank">
                                <FilePdfOutlined />
                            </a>
                        ) : null
                    }
                />
            </Table>
        </div>
    )
}
